import usePostCommentGeneralUtils from '@/hooks/post/comment';
import { TCustomDataMap } from '@/interfaces/hook.interface';
import { postCommentDataMapping } from 'common/commentMapData';
import { PostContext } from 'context/PostContext';
import dynamic from 'next/dynamic';
import { useContext } from 'react';
import { PostInteractionSetterContext } from './provider/PostInteractionProvider';
const CommentSectionWrapper = dynamic(
  () => import('@/components/sections/CommentSection')
);

const PostCommentSection = ({
  openCommentSection,
}: {
  openCommentSection: boolean;
}) => {
  const postInfo = useContext(PostContext);

  const { setCommentCount } = useContext(PostInteractionSetterContext);
  return (
    <>
      {openCommentSection ? (
        <div className="p-[12px_16px]">
          <CommentSectionWrapper
            commentSectionId={postInfo.postId}
            customDataMap={postCommentDataMapping as TCustomDataMap}
            useCommentGeneralUtils={usePostCommentGeneralUtils(
              postInfo.postId,
              (value: number) => {
                setCommentCount((prev) => prev + value);
              }
            )}
          />
        </div>
      ) : null}
    </>
  );
};

export default PostCommentSection;
